import api from "Helpers/Api";
import { CampaignsListResponse } from "Services/Campaigns/campaigns";

export default async function campaignsList() {
  const response = await api.get<CampaignsListResponse>(`/campaign/all`);

  return response;
}
